import { Map } from "immutable";

type Level = "1" | "2" | "3" | "4" | "5";

export const SHADOW = Map<Level, string>({
  1: `box-shadow: 0px 2px 8px 0px #0F20341A;`,
  2: `box-shadow: 0px 4px 14px 0px #0F203412;`,
  3: `box-shadow: 0px 8px 24px 0px #0F203426;`,
  4: `box-shadow: 0px 12px 32px 0px #0F203426;`,
  5: `box-shadow: 0px 20px 40px 0px #0F203433;`,
});

export const GLASS_EFFECT = Map<Level, string>({
  1: `backdrop-filter: blur(12px);`,
  2: `backdrop-filter: blur(20px);`,
  3: `backdrop-filter: blur(28px);`,
  4: `backdrop-filter: blur(36px);`,
});
